module.exports = __webpack_public_path__ + "static/img/new_bussiness_img1.d063463.png";